import Vue from 'vue'
import Router from 'vue-router'

import LocalReconReportPublic from './views/local-recon/ReportPublic.vue'
import LocalReconWidgetsRender from './views/local-recon/WidgetsRender.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: function(to) {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/rf',
      name: 'local_recon_report',
      component: () =>
      import(
        /* webpackChunkName: "contact-us" */ "./views/local-recon/ReportPublic.vue"
      ),
      // component: LocalReconReportPublic
    },
    {
      path: '/local-recon/widgets/render/:token',
      name: 'widgets_render_local_recon',
      component: () =>
      import(
        /* webpackChunkName: "contact-us" */ "./views/local-recon/WidgetsRender.vue"
      ),
      // component: LocalReconWidgetsRender
    }
  ]
})
